import Vue from 'vue'
import Router from 'vue-router'
import Message from '../components/message'
import Lockr from 'lockr'
import store from '../store'
import {
    httpPost
} from "../http/axios";
import GLOBAL from '../config';
import API from '../api/api';
import { isWeiXin } from '../utils/tool';

Vue.use(Router)

const routers = [{
        path: '*',
        component: () => import('@/views/index'),
        meta: {
            title: '金钥匙',
            keepAlive: true, // 是否保持页面数据
        }
    },
    {
        path: '/',
        component: resolve => require(["@/views/home/index"], resolve),
        meta: {
            title: '首页',
            keepAlive: true, // 是否保持页面数据
        }
    },
    {
        path: '/home',
        component: resolve => require(["@/views/home/index"], resolve),
        meta: {
            title: '首页',
            keepAlive: true, // 是否保持页面数据
        }
    },
    {
        path: '/masterUserList',
        component: resolve => require(["@/views/home/masterUserList"], resolve),
        meta: {
            title: '传承师列表',
            // keepAlive: true, // 是否保持页面数据
        }
    },
    {
        path: '/masterUserDetail',
        component: resolve => require(["@/views/home/masterUserDetail"], resolve),
        meta: {
            title: '信息详情',
            // keepAlive: true, // 是否保持页面数据
        }
    },
    /** 文章 */
    {
        path: '/article',
        component: resolve => require(["@/views/home/article"], resolve),
        meta: {
            title: '文章',
        }
    },
    {
        path: '/articleDetail',
        component: resolve => require(["@/views/home/articleDetail"], resolve),
        meta: {
            title: '文章详情',
        }
    },
    {
        path: '/articlePublish',
        component: resolve => require(["@/views/home/articlePublish"], resolve),
        meta: {
            title: '发布文章',
        }
    },
    {
        path: '/myArticle',
        component: resolve => require(["@/views/home/myArticle"], resolve),
        meta: {
            title: '我的文章',
            isLogin: true
        }
    },
    /** 运势 */
    {
        path: '/fortune',
        component: resolve => require(["@/views/home/fortune"], resolve),
        meta: {
            title: '今日运势',
        }
    },
    {
        path: '/fortuneList',
        component: resolve => require(["@/views/home/fortuneList"], resolve),
        meta: {
            title: '历史运势列表',
        }
    },
    /** 沙龙 */
    {
        path: '/salon',
        component: resolve => require(["@/views/salon/salon"], resolve),
        meta: {
            title: '沙龙',
            keepAlive: true
        }
    },
    {
        path: '/salonDetail',
        component: resolve => require(["@/views/salon/salonDetail"], resolve),
        meta: {
            title: '沙龙详情',
        }
    },
    {
        path: '/salonList',
        component: resolve => require(["@/views/salon/salonList"], resolve),
        meta: {
            title: '我的沙龙',
            // keepAlive: true,
            isLogin: true
        }
    },
    {
        path: '/addSalon',
        component: resolve => require(["@/views/salon/addSalon"], resolve),
        meta: {
            title: '发布沙龙',
            isLogin: true
        }
    },
    /** 课程 */
    {
        path: "/course",
        component: resolve => require(["@/views/course/index"], resolve),
        meta: {
            title: "课程",
            keepAlive: true, // 是否保持页面数据
        },
    },
    {
        path: "/courseDetail",
        component: resolve => require(["@/views/course/courseDetail"], resolve),
        meta: {
            title: "课程详情",
        },
    },
    {
        path: "/courseIntroduction",
        component: resolve => require(["@/views/course/courseIntroduction"], resolve),
        meta: {
            title: "课程介绍",
        },
    },
    {
        path: "/courseDetailEnroll",
        component: resolve => require(["@/views/course/courseDetailEnroll"], resolve),
        meta: {
            title: "课程报名",
        },
    },
    {
        path: "/myCourse",
        component: resolve => require(["@/views/course/myCourse"], resolve),
        meta: {
            title: "我的课程",
            isLogin: true
        },
    },
    {
        path: "/myCourseVoucher",
        component: resolve => require(["@/views/course/myCourseVoucher"], resolve),
        meta: {
            title: "课期详情",
        },
    },
    {
        path: "/myCourseEnclosure",
        component: resolve => require(["@/views/course/myCourseEnclosure"], resolve),
        meta: {
            title: "专属附件",
        },
    },
    {
        path: "/volunteers",
        component: resolve => require(["@/views/course/volunteers"], resolve),
        meta: {
            title: "义工记录",
        },
    },
    {
        path: "/volunteersVoucher",
        component: resolve => require(["@/views/course/volunteersVoucher"], resolve),
        meta: {
            title: "服务凭证",
        },
    },

    /** 积分商城 */
    {
        path: "/pointShop",
        component: resolve => require(["@/views/shop_point/pointShop"], resolve),
        meta: {
            title: "易圣金钥匙",
            keepAlive: true, // 是否保持页面数据
        },
    },
    {
        path: "/pointGoodsList",
        component: resolve => require(["@/views/shop_point/pointGoodsList"], resolve),
        meta: {
            title: "全部商品",
        },
    },
    {
        path: "/pointGoodsDetail",
        component: resolve => require(["@/views/shop_point/pointGoodsDetail"], resolve),
        meta: {
            title: "商品详情",
        },
    },
    {
        path: "/pointOrderConfirm",
        component: resolve => require(["@/views/order_point/pointOrderConfirm"], resolve),
        meta: {
            title: "确认订单",
        },
    },
    {
        path: "/pointOrder",
        component: resolve => require(["@/views/order_point/pointOrder"], resolve),
        meta: {
            title: "积分订单",
        },
    },
    {
        path: "/pointOrderDetail",
        component: resolve => require(["@/views/order_point/pointOrderDetail"], resolve),
        meta: {
            title: "积分订单详情",
        },
    },

    /** 商城 */
    {
        path: "/shop1",
        component: resolve => require(["@/views/shop/index1"], resolve),
        meta: {
            title: "易行吉祥阁",
            keepAlive: true, // 是否保持页面数据
        },
    },
    {
        path: "/shop2",
        component: resolve => require(["@/views/shop/index2"], resolve),
        meta: {
            title: "易圣金钥匙",
            keepAlive: true, // 是否保持页面数据
        },
    },
    {
        path: "/goodsList",
        component: resolve => require(["@/views/shop/goodsList"], resolve),
        meta: {
            title: "全部商品",
        },
    },
    {
        path: "/goodsDetail",
        component: resolve => require(["@/views/shop/goodsDetail"], resolve),
        meta: {
            title: "商品详情",
        },
    },
    {
        path: "/cart",
        component: resolve => require(["@/views/cart/index"], resolve),
        meta: {
            title: "购物车",
            isLogin: true
        },
    },
    {
        path: "/address",
        component: resolve => require(["@/views/address/address"], resolve),
        meta: {
            title: "地址管理",
            isLogin: true
        },
    },
    {
        path: "/addAddress",
        component: resolve => require(["@/views/address/addAddress"], resolve),
        meta: {
            title: "添加地址",
            isLogin: true
        },
    },
    {
        path: "/checkIn",
        component: resolve => require(["@/views/mine/checkIn"], resolve),
        meta: {
            title: "签到",
            isLogin: true
        },
    },
    {
        path: "/order",
        component: resolve => require(["@/views/order/index"], resolve),
        meta: {
            title: "订单",
            keepAlive: false, // 是否保持页面数据
            isLogin: true
        },
    },
    {
        path: "/orderDetail",
        component: resolve => require(["@/views/order/orderDetail"], resolve),
        meta: {
            title: "订单详情",
            isLogin: true
        },
    },
    {
        path: "/orderConfirm",
        component: resolve => require(["@/views/order/orderConfirm"], resolve),
        meta: {
            title: "确认订单",
            isLogin: true
        },
    },
    {
        path: "/logistics",
        component: resolve => require(["@/views/order/logistics"], resolve),
        meta: {
            title: "物流详情",
            isLogin: true
        },
    },
    {
        path: "/refund",
        component: resolve => require(["@/views/order/refund"], resolve),
        meta: {
            title: "申请退款",
            isLogin: true
        },
    },
    {
        path: "/refundRecord",
        component: resolve => require(["@/views/order/refundRecord"], resolve),
        meta: {
            title: "退款记录",
            isLogin: true
        },
    },
    {
        path: "/mine",
        component: resolve => require(["@/views/mine/index"], resolve),
        meta: {
            title: "我的",
        },
    },
    {
        path: "/userinfo",
        component: resolve => require(["@/views/mine/userinfo"], resolve),
        meta: {
            title: "个人资料",
            isLogin: true
        },
    },
    {
        path: "/identify",
        component: resolve => require(["@/views/mine/identify"], resolve),
        meta: {
            title: "实名认证",
            isLogin: true
        },
    },
    {
        path: "/changeMobile",
        component: resolve => require(["@/views/mine/changeMobile"], resolve),
        meta: {
            title: "更换手机号",
            isLogin: true
        },
    },
    {
        path: "/changePassword",
        component: resolve => require(["@/views/mine/changePassword"], resolve),
        meta: {
            title: "更换登录密码",
            isLogin: true
        },
    },
    {
        path: "/withdrawal",
        component: resolve => require(["@/views/withdrawal/withdrawal"], resolve),
        meta: {
            title: "提现",
            isLogin: true
        },
    },
    {
        path: "/withdrawalApply",
        component: resolve => require(["@/views/withdrawal/withdrawalApply"], resolve),
        meta: {
            title: "申请提现",
            isLogin: true
        },
    },

    /** 账户 */
    {
        path: "/login",
        component: resolve => require(["@/views/login/login"], resolve),
        meta: {
            title: "登陆",
            isNoAuthor: true,
        },
    },
    {
        path: "/forget",
        component: resolve => require(["@/views/login/forget"], resolve),
        meta: {
            title: "找回密码",
            isNoAuthor: true,
        },
    },
    {
        path: "/register",
        component: resolve => require(["@/views/login/register"], resolve),
        meta: {
            title: "注册",
            isNoAuthor: true,
        },
    },
    {
        path: "/bindMobile",
        component: resolve => require(["@/views/login/bindMobile"], resolve),
        meta: {
            title: "绑定手机号",
            isNoAuthor: true,
        },
    },
    {
        path: '/mySalon',
        component: resolve => require(["@/views/salon/mySalon"], resolve),
        meta: {
            title: '我的沙龙',
            isLogin: true
        }
    },
    /** 其他 */
    {
        path: "/question",
        component: resolve => require(["@/views/mine/question"], resolve),
        meta: {
            title: "常见问题",
        },
    },
    {
        path: "/contactUs",
        component: resolve => require(["@/views/mine/contactUs"], resolve),
        meta: {
            title: "联系我们",
        },
    },
    {
        path: "/aboutUs",
        component: resolve => require(["@/views/mine/aboutUs"], resolve),
        meta: {
            title: "关于我们",
        },
    },
    {
        path: "/message",
        component: resolve => require(["@/views/mine/message"], resolve),
        meta: {
            title: "消息",
        },
    },
    {
        path: "/bill",
        component: resolve => require(["@/views/mine/bill"], resolve),
        meta: {
            title: "缴费记录",
            isLogin: true
        },
    },
    {
        path: "/myPoints",
        component: resolve => require(["@/views/mine/myPoints"], resolve),
        meta: {
            title: "我的积分",
            isLogin: true
        },
    },
    /** 传承师 */
    {
        path: "/myInheritorInfo",
        component: resolve => require(["@/views/mine/inheritor/myInheritorInfo"], resolve),
        meta: {
            title: "传承师信息",
            isLogin: true
        },
    },
    {
        path: "/myInheritorApply",
        component: resolve => require(["@/views/mine/inheritor/myInheritorApply"], resolve),
        meta: {
            title: "传承师信息",
            isLogin: true
        },
    },
    {
        path: "/inheritorDetail",
        component: resolve => require(["@/views/mine/inheritor/inheritorDetail"], resolve),
        meta: {
            title: "传承师信息",
            isLogin: true
        },
    },
    {
        path: "/myInheritorTeam",
        component: resolve => require(["@/views/mine/inheritor/myInheritorTeam"], resolve),
        meta: {
            title: "我的传承师团队",
            isLogin: true
        },
    },
    {
        path: "/studentInfo",
        component: resolve => require(["@/views/student/studentInfo"], resolve),
        meta: {
            title: "学员详情",
            isLogin: true
        },
    },
    {
        path: "/myIncome",
        component: resolve => require(["@/views/mine/myIncome"], resolve),
        meta: {
            title: "课程收入",
            isLogin: true
        },
    },
    /** 代理商 */
    {
        path: "/myAgentInfo",
        component: resolve => require(["@/views/mine/agent/myAgentInfo"], resolve),
        meta: {
            title: "代理商信息",
            isLogin: true
        },
    },
    {
        path: "/myAgentApply",
        component: resolve => require(["@/views/mine/agent/myAgentApply"], resolve),
        meta: {
            title: "代理商申请",
            isLogin: true
        },
    },
    {
        path: "/lecturerDetail",
        component: resolve => require(["@/views/mine/agent/lecturerDetail"], resolve),
        meta: {
            title: "代理商信息(废弃)",
            isLogin: true
        },
    },
    {
        path: "/courseRecord",
        component: resolve => require(["@/views/mine/agent/courseRecord"], resolve),
        meta: {
            title: "课程记录",
            isLogin: true
        },
    },
    {
        path: "/courseParticipant",
        component: resolve => require(["@/views/mine/agent/courseParticipant"], resolve),
        meta: {
            title: "课程报名列表",
            isLogin: true
        },
    },
    {
        path: "/myAgentTeam",
        component: resolve => require(["@/views/mine/agent/myAgentTeam"], resolve),
        meta: {
            title: "我的代理商团队",
            isLogin: true
        },
    },
    {
        path: "/myTicket",
        component: resolve => require(["@/views/mine/myTicket"], resolve),
        meta: {
            title: "我的门票",
            isLogin: true
        }
    },
    {
        path: "/myTicketGift",
        component: resolve => require(["@/views/mine/myTicketGift"], resolve),
        meta: {
            title: "解锁门票",
            isLogin: true
        }
    },
    {
        path: "/salonParticipant",
        component: resolve => require(["@/views/mine/agent/salonParticipant"], resolve),
        meta: {
            title: "我的沙龙列表",
            isLogin: true
        },
    }
]

const RouterConfig = {
    // mode: 'history',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: routers
}
const router = new Router(RouterConfig)
router.beforeEach((to, from, next) => {

    document.title = to.meta.title;
    let code = getParamer('code')
    let login_type = getParamer('state')

    let __uid__ = to.query.uid
    let __token__ = Lockr.get('token')

    console.log('router to, code, login_type, __uid__, __token__---->', to, code, login_type, __uid__, __token__);

    if (__uid__) {
        let data = {
            pid: __uid__,
        }
        httpPost(API.login_bind_agent, data)
            .then((result) => {
                console.log('result---->', result);
            });
    }


    if (code && login_type) {

        // let userInfoTemp = {
        //     agent_id: 0,
        //     avatar: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIBicEibaY3whayOYq6WiakL1dZkC1oxicnPsaG4M37bF0INnvKFvqKfKePBRQFk2aSDKF8oW8JKhzcrw/132",
        //     h5_openid: "oYdgT6Zy2iVYAwpl41E44TNOqU3E",
        //     is_fans: 1,
        //     mobile: "",
        //     name: "梦",
        //     sex: 0,
        //     team_member_time: 1689931070,
        //     // token: "3f7d271e2e04d5e773efdbadf987b94e",
        //     unionid: "oaBqvuHeG0gMaAPD2T9d1U-MVjr4",
        // }
        // Lockr.set("wx_data", userInfoTemp);
        // if (!userInfoTemp.mobile) {
        //     window.location.replace('http://localhost:8088/#/bindMobile?type=no_user');
        //     // window.location.replace(GLOBAL.H5_domain + '/#/bindMobile?type=no_user');
        // }


        let params = {
            code: code
        }
        // 授权登录-code换取登录信息
        httpPost(API.oauth_callback, params).then(result => {
            Message({
                title: result.msg
            });

            if (result.code === GLOBAL.SUCCESS_CODE) {
                let userInfoTemp = result.data;
                Lockr.set("wx_data", userInfoTemp);
                console.log('wechatUserInfo---->', 'wechatUserInfo');
                let backPath = Lockr.get('backPath')
                console.log('backPath---->', backPath);
                // 没绑定手机号去绑定手机号
                if (!userInfoTemp.mobile) {
                    window.location.replace(GLOBAL.H5_domain + '/#/bindMobile?type=no_user');
                } else {
                    Lockr.set("token", userInfoTemp.token);
                    if (backPath) {
                        console.log('oauth_callback 111---->', 111);
                        window.location.replace(GLOBAL.H5_domain + '/#' + backPath)
                        Lockr.rm('backPath')
                    } else {
                        console.log('oauth_callback 222---->', 222);
                        window.location.replace(GLOBAL.H5_domain)
                    }
                }
            }
        });
        return
    }
    if (__token__) {
        if (!store.state.userInfo) {
            store.dispatch('UserInfo').then((result) => {
                console.log('result---->', result);
                // 获取用户信息
                if (result.code != GLOBAL.SUCCESS_CODE) {
                    Lockr.rm('token');
                    router.push({
                        path: '/login'
                    });
                }
            }).catch(err => {
                Message({
                    title: err.msg
                })
            })
        }
        if (!store.state.service) {
            store.dispatch('Service')
        }
    }

    if (to.meta.isLogin) {
        console.log('to', to)
        if (!__token__) {
            Lockr.set('backPath', to.fullPath)
            router.push({
                path: '/login'
            })
        } else {
            next()
        }
    } else {
        if (isWeiXin() && !to.meta.isNoAuthor && !__token__) {
            // 微信自动登录
            console.log('微信自动登录---->', '微信自动登录');
            Lockr.set('backPath', to.fullPath)
            router.push({
                path: '/login'
            })
        } else {

            next()
        }
    }
})
// 获取url参数
function getParamer(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; //返回参数值
}

export default router